import { FC } from 'react';
import SupportIcon from '../../assets/support.svg';

export const DISABLED_SUPPORT_SKILL_TOOLTIP =
  'Disabled in the interactive demo, but students will see it on their platform.';

interface Props {
  skillName: string;
}

export const DisabledSupportSkillItem: FC<Props> = ({ skillName }) => (
  <span
    className="nc_support-skill-disabled flex-grow-1 tw-flex tw-items-center tw-gap-2 tw-cursor-not-allowed tw-text-neutral-600"
    aria-disabled="true"
    tabIndex={0}
    data-pr-tooltip={DISABLED_SUPPORT_SKILL_TOOLTIP}
  >
    <img src={SupportIcon} alt="" className="tw-h-[1.5rem] tw-w-[1.5rem] tw-shrink-0 tw-opacity-40" />
    {skillName}
    <span className="tw-sr-only"> {DISABLED_SUPPORT_SKILL_TOOLTIP}</span>
  </span>
);
